import React from 'react';

const RestoreEmailTemplate = ({
  recipientName,
  contractTitle,
  contractId,
  previousStatus,
  userName,
  actionDate,
  actionReason,
  contractUrl,
  status
}) => {
  const currentYear = new Date().getFullYear();

  const getEmailBody = () => {
    return `
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
        <tr>
          <td align="center" style="padding: 20px 0;">
            <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
              <!-- Header -->
              <tr>
                <td style="background-color: #ff6b35; padding: 30px 20px; text-align: center;">
                  <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #ffffff;">
                    <span style="color: #ffffff;">CRITICAL</span>RIVER
                  </h1>
                  <p style="margin: 10px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Contract Lifecycle Management</p>
                </td>
              </tr>
              <!-- Body -->
              <tr>
                <td style="padding: 40px 30px; background-color: #ffffff;">
                  <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 20px;">🔄 Contract Restored Successfully</h2>
                  <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">Dear ${recipientName || 'User'},</p>
                  <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">This is to notify you that the following contract has been restored from the archive and is now active in the CriticalRiver CLM system.</p>
                  <!-- Alert Box -->
                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #d4edda; border: 1px solid #28a745; border-radius: 6px; padding: 16px 20px; margin: 20px 0;">
                    <tr>
                      <td style="padding-right: 12px; font-size: 20px; color: #28a745;">✓</td>
                      <td>
                        <strong style="color: #333333; display: block; margin-bottom: 4px;">Restore Action Completed</strong>
                        <p style="margin: 0; color: #666666; font-size: 14px;">The contract has been successfully restored and is now active in the system.</p>
                      </td>
                    </tr>
                  </table>
                  <!-- Contract Card -->
                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f8f9fa; border-radius: 8px; border: 2px solid #ff6633; margin: 24px 0;">
                    <tr>
                      <td style="padding: 24px;">
                        <h3 style="margin: 0 0 16px 0; color: #333333; font-size: 18px; display: flex; align-items: center;">📄 Restored Contract Details</h3>
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                          <tr>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; width: 45%; font-size: 15px;">Contract Status:</td>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${previousStatus || 'N/A'}</td>
                          </tr>
                          <tr>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Current Stage:</td>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">
                              <span style="display: inline-block; padding: 4px 12px; background-color: #ffa500; color: #ffffff; border-radius: 6px; font-size: 12px; font-weight: 600;">${status || 'Active'}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Restored By:</td>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${userName || 'N/A'}</td>
                          </tr>
                          <tr>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Restored On:</td>
                            <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${actionDate || 'N/A'}</td>
                          </tr>
                          <tr>
                            <td style="padding: 10px 0; font-weight: 600; color: #555555; font-size: 15px;">Restore Reason:</td>
                            <td style="padding: 10px 0; color: #666666; font-size: 15px;">${actionReason || 'N/A'}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <!-- CTA Button -->
                  
                  <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">If you have any questions or need assistance with this contract, please contact the CLM team or reply to this email.</p>
                  <p style="margin: 0 0 5px 0; color: #666666; line-height: 1.6; font-size: 15px;">Best regards,</p>
                  <p style="margin: 0; color: #666666; line-height: 1.6; font-size: 15px;"><strong>The CriticalRiver BTG Team</strong></p>
                </td>
              </tr>
              <!-- Footer -->
              <tr>
                <td style="background-color: #2c3e50; padding: 30px; text-align: center;">
                  <p style="margin: 0 0 10px 0; color: #bbbbbb; font-size: 13px;">&copy; ${currentYear} CriticalRiver. All rights reserved.</p>
                 
                  <p style="margin: 10px 0 0 0; color: #bbbbbb; font-size: 13px;">This is an automated notification from CriticalRiver BTG Team</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;
  };

  const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Contract Restored</title>
    </head>
    <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f5f5f5;">
      ${getEmailBody()}
    </body>
    </html>
  `;

  return htmlContent;
};

export default RestoreEmailTemplate;